jQuery(document).ready(function($) {


    if ($("body").hasClass("search")) {
        $(function () {
            // Get all CPT
            var array_classes = [];
            $('.search-item-container').each(function (i) {
                class_name = $(this).attr('class').split(' ')[1]; // To exclude the search-item-container class
                if ($.inArray(class_name, array_classes) == -1) { // not in array
                    array_classes.push(class_name);
                }
            });
            // Count CPT
            $.each(array_classes, function (index, value) {
                var num_items = $('.section-search-results').children("." + value).length;
                switch (value) {
                    case "news":
                        custom_value = "news";
                        break;
                    case "equipment" :
                        custom_value = "equipment";
                        break;
                    case "projects":
                        custom_value = "projects";
                        break;
                    case "events":
                        custom_value = "events";
                        break;
                    case "page":
                        custom_value = "others";
                        break;
                    default:
                        custom_value = value;
                }
                $("#cpt-list").append("<div class='item-cpt'><a class='item nav-main-link not-anchor' href='#' data-target=" + value + ">" + custom_value + " (" + num_items + ") " + "</a></div>");
            });

        });
        // At the beginning, only results of the first item is displayed
        $(function () {
            $(".search-item-container").hide();
            var first_menu = $("#cpt-list .item-cpt a.item").first().data("target");
            $("." + first_menu).show();
            // the first menu is the active item
            $("#cpt-list .item-cpt a.item").first().addClass("current-menu-item-cpt");
        });
        // Click management
        $(function () {
            $('.item-cpt a.item').on('click', function (e) {
                e.preventDefault();
                $(".search-item-container").hide();
                target_cpt = $(this).attr('data-target');
                $("." + target_cpt).show();
                // the current item is the active item
                $(".item-cpt a.item").removeClass("current-menu-item-cpt");
                $(this).addClass("current-menu-item-cpt");
            });
        });

    }
});